module.exports = __webpack_public_path__ + "static/media/hair (59).d731ca5d.jpg";